import { render, staticRenderFns } from "./TaxesIncentivesTab.vue?vue&type=template&id=28631356&scoped=true&"
import script from "./TaxesIncentivesTab.vue?vue&type=script&lang=js&"
export * from "./TaxesIncentivesTab.vue?vue&type=script&lang=js&"
import style0 from "./TaxesIncentivesTab.vue?vue&type=style&index=0&id=28631356&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28631356",
  null
  
)

export default component.exports